import NavLinks from "./NavLinks";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import { useState } from "react";

const MobileNavigation = () => {
  const [click, setClick] = useState(false);

  const toggleClass = () => {
    setClick(!click);
  };

  return (
    <nav className="mobileNavigation">
      {click ? (
        <AiOutlineClose className="burgermenu" onClick={toggleClass} />
      ) : (
        <GiHamburgerMenu className="burgermenu" onClick={toggleClass} />
      )}
      {click && <NavLinks />}
    </nav>
  );
};

export default MobileNavigation;
